import { t as e } from "./rolldown-runtime-CAFD8bLK.js";
import { f as t, g as n, i as r, l as i, m as a, n as o, p as s, r as c, s as l, t as u } from "./defaultCommentEditorSchema-BkS69xQH.js";
import d, { useCallback as f, useEffect as p, useMemo as m, useRef as h, useState as g, useSyncExternalStore as _ } from "react";
import { CommentsExtension as v } from "@blocknote/core/comments";
import { flip as y, offset as b, shift as x } from "@floating-ui/react";
import { mergeCSSClasses as S } from "@blocknote/core";
import { Fragment as C, jsx as w, jsxs as T } from "react/jsx-runtime";
import { RiArrowGoBackFill as E, RiCheckFill as D, RiDeleteBinFill as O, RiEditFill as k, RiEmotionLine as A, RiMoreFill as j } from "react-icons/ri";
//#region src/components/Comments/EmojiMartPicker.tsx
var M;
async function N() {
	return M || (M = (async () => {
		let [e, t] = await Promise.all([import("emoji-mart"), import("@emoji-mart/data")]), n = "default" in e ? e.default : e, r = "default" in t ? t.default : t;
		return await n.init({ data: r }), {
			emojiMart: n,
			emojiData: r
		};
	})(), M);
}
function P(e) {
	let t = h(null), n = h(null);
	return n.current && n.current.update(e), p(() => ((async () => {
		let { emojiMart: r } = await N();
		n.current = new r.Picker({
			...e,
			ref: t
		});
	})(), () => {
		n.current = null;
	}), []), d.createElement("div", { ref: t });
}
//#endregion
//#region src/components/Comments/EmojiPicker.tsx
var F = (e) => {
	let [t, r] = g(!1), a = i(), o = n(), s = o.editor?.portalElement;
	if (!s) throw Error("Portal root not found");
	return /* @__PURE__ */ T(a.Generic.Popover.Root, {
		open: t,
		portalRoot: s,
		children: [/* @__PURE__ */ w(a.Generic.Popover.Trigger, { children: /* @__PURE__ */ w("div", {
			onClick: (n) => {
				n.preventDefault(), n.stopPropagation(), r(!t), e.onOpenChange?.(!t);
			},
			style: {
				display: "flex",
				justifyContent: "center",
				alignItems: "center"
			},
			children: e.children
		}) }), /* @__PURE__ */ w(a.Generic.Popover.Content, {
			className: "bn-emoji-picker-popover",
			variant: "panel-popover",
			children: /* @__PURE__ */ w(P, {
				perLine: 7,
				onClickOutside: () => {
					r(!1), e.onOpenChange?.(!1);
				},
				onEmojiSelect: (t) => {
					e.onEmojiSelect(t), r(!1), e.onOpenChange?.(!1);
				},
				theme: o?.colorSchemePreference
			})
		})]
	});
};
//#endregion
//#region src/components/Comments/useUsers.ts
function I(e) {
	return L([e]).get(e);
}
function L(e) {
	let n = t(v).userStore, r = f(() => {
		let t = /* @__PURE__ */ new Map();
		for (let r of e) {
			let e = n.getUser(r);
			e && t.set(r, e);
		}
		return t;
	}, [n, e]), i = m(() => ({ current: r() }), [r]);
	return _(f((t) => {
		let a = n.subscribe((e) => {
			i.current = r(), t();
		});
		return n.loadUsers(e), a;
	}, [
		n,
		r,
		e,
		i
	]), () => i.current);
}
//#endregion
//#region src/components/Comments/ReactionBadge.tsx
var R = (e) => {
	let n = i(), r = l(), a = t(v), o = e.comment.reactions.find((t) => t.emoji === e.emoji);
	if (!o) throw Error("Trying to render reaction badge for non-existing reaction");
	let [s, c] = g([]), u = L(s);
	return /* @__PURE__ */ w(n.Generic.Badge.Root, {
		className: S("bn-badge", "bn-comment-reaction"),
		text: o.userIds.length.toString(),
		icon: o.emoji,
		isSelected: a.threadStore.auth.canDeleteReaction(e.comment, o.emoji),
		onClick: () => e.onReactionSelect(o.emoji),
		onMouseEnter: () => c(o.userIds),
		mainTooltip: r.comments.reactions.reacted_by,
		secondaryTooltip: `${Array.from(u.values()).map((e) => e.username).join("\n")}`
	}, o.emoji);
}, z = ({ comment: e, thread: n, showResolveButton: r }) => {
	let a = t(v), s = l(), d = c({
		initialContent: e.body,
		trailingBlock: !1,
		dictionary: {
			...s,
			placeholders: { emptyDocument: s.placeholders.edit_comment }
		},
		schema: a.commentEditorSchema || u
	}), p = i(), [m, h] = g(!1), [_, y] = g(!1), b = a.threadStore, x = f(() => {
		h(!0);
	}, []), M = f(() => {
		d.replaceBlocks(d.document, e.body), h(!1);
	}, [d, e.body]), N = f(async (t) => {
		await b.updateComment({
			commentId: e.id,
			comment: { body: d.document },
			threadId: n.id
		}), h(!1);
	}, [
		e,
		n.id,
		d,
		b
	]), P = f(async () => {
		await b.deleteComment({
			commentId: e.id,
			threadId: n.id
		});
	}, [
		e,
		n.id,
		b
	]), L = f(async (t) => {
		b.auth.canAddReaction(e, t) ? await b.addReaction({
			threadId: n.id,
			commentId: e.id,
			emoji: t
		}) : b.auth.canDeleteReaction(e, t) && await b.deleteReaction({
			threadId: n.id,
			commentId: e.id,
			emoji: t
		});
	}, [
		b,
		e,
		n.id
	]), z = f(async () => {
		await b.resolveThread({ threadId: n.id });
	}, [n.id, b]), B = f(async () => {
		await b.unresolveThread({ threadId: n.id });
	}, [n.id, b]), V = I(e.userId);
	if (!e.body) return null;
	let H, U = b.auth.canAddReaction(e), W = b.auth.canDeleteComment(e), G = b.auth.canUpdateComment(e), K = r && (n.resolved ? b.auth.canUnresolveThread(n) : b.auth.canResolveThread(n));
	m || (H = /* @__PURE__ */ T(p.Generic.Toolbar.Root, {
		className: S("bn-action-toolbar", "bn-comment-actions"),
		variant: "action-toolbar",
		children: [
			U && /* @__PURE__ */ w(F, {
				onEmojiSelect: (e) => L(e.native),
				onOpenChange: y,
				children: /* @__PURE__ */ w(p.Generic.Toolbar.Button, {
					mainTooltip: s.comments.actions.add_reaction,
					variant: "compact",
					children: /* @__PURE__ */ w(A, { size: 16 })
				}, "add-reaction")
			}),
			K && (n.resolved ? /* @__PURE__ */ w(p.Generic.Toolbar.Button, {
				mainTooltip: s.comments.actions.reopen,
				variant: "compact",
				onClick: B,
				children: /* @__PURE__ */ w(E, { size: 16 })
			}, "reopen") : /* @__PURE__ */ w(p.Generic.Toolbar.Button, {
				mainTooltip: s.comments.actions.resolve,
				variant: "compact",
				onClick: z,
				children: /* @__PURE__ */ w(D, { size: 16 })
			}, "resolve")),
			(W || G) && /* @__PURE__ */ T(p.Generic.Menu.Root, {
				position: "bottom-start",
				children: [/* @__PURE__ */ w(p.Generic.Menu.Trigger, { children: /* @__PURE__ */ w(p.Generic.Toolbar.Button, {
					mainTooltip: s.comments.actions.more_actions,
					variant: "compact",
					children: /* @__PURE__ */ w(j, { size: 16 })
				}, "more-actions") }), /* @__PURE__ */ T(p.Generic.Menu.Dropdown, {
					className: "bn-menu-dropdown",
					children: [G && /* @__PURE__ */ w(p.Generic.Menu.Item, {
						icon: /* @__PURE__ */ w(k, {}),
						onClick: x,
						children: s.comments.actions.edit_comment
					}, "edit-comment"), W && /* @__PURE__ */ w(p.Generic.Menu.Item, {
						icon: /* @__PURE__ */ w(O, {}),
						onClick: P,
						children: s.comments.actions.delete_comment
					}, "delete-comment")]
				})]
			})
		]
	}));
	let q = e.createdAt.toLocaleDateString(void 0, {
		month: "short",
		day: "numeric"
	});
	if (!e.body) throw Error("soft deletes are not yet supported");
	return /* @__PURE__ */ w(p.Comments.Comment, {
		authorInfo: V ?? "loading",
		timeString: q,
		edited: e.updatedAt.getTime() !== e.createdAt.getTime(),
		showActions: "hover",
		actions: H,
		className: "bn-thread-comment",
		emojiPickerOpen: _,
		children: /* @__PURE__ */ w(o, {
			autoFocus: m,
			editor: d,
			editable: m,
			actions: e.reactions.length > 0 || m ? ({ isEmpty: t }) => /* @__PURE__ */ T(C, { children: [e.reactions.length > 0 && !m && /* @__PURE__ */ T(p.Generic.Badge.Group, {
				className: S("bn-badge-group", "bn-comment-reactions"),
				children: [e.reactions.map((t) => /* @__PURE__ */ w(R, {
					comment: e,
					emoji: t.emoji,
					onReactionSelect: L
				}, t.emoji)), U && /* @__PURE__ */ w(F, {
					onEmojiSelect: (e) => L(e.native),
					onOpenChange: y,
					children: /* @__PURE__ */ w(p.Generic.Badge.Root, {
						className: S("bn-badge", "bn-comment-add-reaction"),
						text: "+",
						icon: /* @__PURE__ */ w(A, { size: 16 }),
						mainTooltip: s.comments.actions.add_reaction
					})
				})]
			}), m && /* @__PURE__ */ T(p.Generic.Toolbar.Root, {
				variant: "action-toolbar",
				className: S("bn-action-toolbar", "bn-comment-actions"),
				children: [/* @__PURE__ */ w(p.Generic.Toolbar.Button, {
					mainTooltip: s.comments.save_button_text,
					variant: "compact",
					onClick: N,
					isDisabled: t,
					children: s.comments.save_button_text
				}), /* @__PURE__ */ w(p.Generic.Toolbar.Button, {
					className: "bn-button",
					mainTooltip: s.comments.cancel_button_text,
					variant: "compact",
					onClick: M,
					children: s.comments.cancel_button_text
				})]
			})] }) : void 0
		})
	});
}, B = ({ thread: e, maxCommentsBeforeCollapse: t }) => {
	let n = i(), r = l(), a = L(e.resolvedBy ? [e.resolvedBy] : []), o = e.comments.map((t, n) => /* @__PURE__ */ w(z, {
		thread: e,
		comment: t,
		showResolveButton: n === 0
	}, t.id + JSON.stringify(t.body || "{}")));
	if (e.resolved && e.resolvedUpdatedAt && e.resolvedBy) {
		if (!a.get(e.resolvedBy)) throw Error(`User ${e.resolvedBy} resolved thread ${e.id}, but their data could not be found.`);
		let t = e.comments.findLastIndex((t) => e.resolvedUpdatedAt.getTime() > t.createdAt.getTime()) + 1;
		o.splice(t, 0, /* @__PURE__ */ w(n.Comments.Comment, {
			className: "bn-thread-comment",
			authorInfo: e.resolvedBy && a.get(e.resolvedBy) || "loading",
			timeString: e.resolvedUpdatedAt.toLocaleDateString(void 0, {
				month: "short",
				day: "numeric"
			}),
			edited: !1,
			showActions: !1,
			children: /* @__PURE__ */ w("div", {
				className: "bn-resolved-text",
				children: r.comments.sidebar.marked_as_resolved
			})
		}, "resolved-comment"));
	}
	return t && o.length > t && o.splice(1, o.length - 2, /* @__PURE__ */ w(n.Comments.ExpandSectionsPrompt, {
		className: "bn-thread-expand-prompt",
		children: r.comments.sidebar.more_replies(e.comments.length - 2)
	}, "expand-prompt")), o;
}, V = ({ thread: e, selected: n, referenceText: r, maxCommentsBeforeCollapse: a, onFocus: s, onBlur: d, tabIndex: p }) => {
	let m = i(), h = l(), g = t(v), _ = c({
		trailingBlock: !1,
		dictionary: {
			...h,
			placeholders: { emptyDocument: h.placeholders.comment_reply }
		},
		schema: g.commentEditorSchema || u
	}), y = f(async () => {
		await g.threadStore.addComment({
			comment: { body: _.document },
			threadId: e.id
		}), _.removeBlocks(_.document);
	}, [
		g,
		_,
		e.id
	]);
	return /* @__PURE__ */ T(m.Comments.Card, {
		className: "bn-thread",
		headerText: r,
		onFocus: s,
		onBlur: d,
		selected: n,
		tabIndex: p,
		children: [/* @__PURE__ */ w(m.Comments.CardSection, {
			className: "bn-thread-comments",
			children: /* @__PURE__ */ w(B, {
				thread: e,
				maxCommentsBeforeCollapse: n ? void 0 : a || 5
			})
		}), n && /* @__PURE__ */ w(m.Comments.CardSection, {
			className: "bn-thread-composer",
			children: /* @__PURE__ */ w(o, {
				autoFocus: !1,
				editable: !0,
				editor: _,
				actions: ({ isEmpty: e }) => e ? null : /* @__PURE__ */ w(m.Generic.Toolbar.Root, {
					variant: "action-toolbar",
					className: S("bn-action-toolbar", "bn-comment-actions"),
					children: /* @__PURE__ */ w(m.Generic.Toolbar.Button, {
						mainTooltip: h.comments.save_button_text,
						variant: "compact",
						isDisabled: e,
						onClick: y,
						children: h.comments.save_button_text
					})
				})
			})
		})]
	});
};
//#endregion
//#region src/components/Comments/useThreads.ts
function H() {
	let e = t(v).threadStore, n = h(void 0);
	return n.current ||= e.getThreads(), _(f((t) => e.subscribe((e) => {
		n.current = e, t();
	}), [e]), () => n.current);
}
//#endregion
//#region src/components/Comments/FloatingThreadController.tsx
var U = /* @__PURE__ */ e({ default: () => W });
function W(e) {
	let n = a(), i = t(v), o = s(v, {
		editor: n,
		selector: (e) => e.selectedThreadId ? {
			id: e.selectedThreadId,
			position: e.threadPositions.get(e.selectedThreadId)
		} : void 0
	}), c = H(), l = m(() => o ? c.get(o.id) : void 0, [o, c]), u = m(() => ({
		...e.floatingUIOptions,
		useFloatingOptions: {
			open: !!o,
			onOpenChange: (e, t, r) => {
				r === "escape-key" && n.focus(), e || i.selectThread(void 0);
			},
			placement: "bottom",
			middleware: [
				b(10),
				x(),
				y()
			],
			...e.floatingUIOptions?.useFloatingOptions
		},
		focusManagerProps: {
			disabled: !0,
			...e.floatingUIOptions?.focusManagerProps
		},
		elementProps: {
			style: { zIndex: 30 },
			...e.floatingUIOptions?.elementProps
		}
	}), [
		i,
		n,
		e.floatingUIOptions,
		o
	]), d = e.floatingThread || V;
	return /* @__PURE__ */ w(r, {
		position: o?.position,
		...u,
		children: l && /* @__PURE__ */ w(d, {
			thread: l,
			selected: !0
		})
	});
}
//#endregion
export { B as a, L as c, V as i, U as n, z as o, H as r, I as s, W as t };

//# sourceMappingURL=FloatingThreadController-DXD0P6RJ.js.map